import EmailWorkFlowTable from "./EmailWorkFlowTable";

const EmailWorkFlow = () => {
  return (
    <div className="overflow-auto">
      <EmailWorkFlowTable />
    </div>
  );
};

export default EmailWorkFlow;
